import { useTranslation } from 'react-i18next';

import styles from './no-files-label.module.scss';

export const NoFilesLabel = ({ text } : { text?: string }) => {
  const { t } = useTranslation();

  return <label className={styles.noFiles}>{!text ? t('zero_files_total') : text}</label>;
};
